import { LinkingOptions } from '@react-navigation/native';
import { Platform } from 'react-native';

export const linking: LinkingOptions<any> = {
  prefixes: Platform.select({
    web: ['http://localhost:19006', 'https://yourdomain.com', 'https://app.invoiceai.com'],
    default: ['invoiceai://', 'https://app.invoiceai.com'],
  }) || [],
  config: {
    screens: {
      AcceptInvitation: {
        path: 'accept-invitation',
        parse: {
          token: (token: string) => token,
        },
      },
      TabNavigator: {
        screens: {
          Dashboard: {
            path: '/dashboard',
          },
          Purchases: {
            path: '/purchases',
            screens: {
              PurchaseList: '',
              PurchaseDetail: '/:purchaseId',
              PurchaseEdit: '/:purchaseId/edit',
              CapturePurchase: '/capture',
              PurchaseExtraction: '/extraction',
              VendorPayment: '/payment',
            },
          },
          // Legacy invoice routes for backward compatibility
          Invoices: {
            path: '/invoices',
            screens: {
              InvoiceList: '',
              InvoiceDetail: '/:invoiceId',
              CaptureInvoice: '/capture',
              ExtractionResult: '/extraction',
            },
          },
          Vendors: {
            path: '/vendors',
            screens: {
              SupplierList: '',
              SupplierDetail: '/:supplierId',
              SupplierEdit: '/:supplierId/edit',
              SupplierCapture: '/capture',
            },
          },
          // Legacy supplier routes for backward compatibility
          Suppliers: {
            path: '/suppliers',
            screens: {
              SupplierList: '',
              SupplierDetail: '/:supplierId',
              SupplierEdit: '/:supplierId/edit',
              SupplierCapture: '/capture',
            },
          },
          Inventory: {
            path: '/inventory',
            screens: {
              InventoryList: '',
              InventoryItemDetail: '/:itemId',
              InventoryItemForm: '/form',
              InventoryItemCapture: '/capture',
              StockMovements: '/movements',
              StockTransfer: '/transfer',
              StockTake: '/stock-take',
              StockAnalytics: '/analytics',
              StockTakeApprovals: '/approvals',
            },
          },
          Profile: {
            path: '/profile',
            screens: {
              Profile: '',
              ThemeSettings: '/theme',
              AccountSettings: '/account',
              TeamManagement: '/team',
              HelpSupport: '/help',
              HelpCategory: '/help/category/:categoryId',
              HelpArticleDetail: '/help/article/:articleId',
              HelpFeedback: '/help/feedback',
              OrganizationSettings: '/organization',
              OrganizationEdit: '/organization/edit',
              OrganizationCapture: '/organization/capture',
              OrganizationMembers: '/organization/members',
            },
          },
        },
      },
      Login: '/login',
      Register: '/register',
      ForgotPassword: '/forgot-password',
      DataMigration: '/admin/migration',
    },
  },
};